<div class="dialog-container">
  <oph-x-button class="cb-reward-dialog__close-button" (click)="onCancel()" title="Close dialog" />
  <cb-dialog-header
    icon="assets/img/icons/challenge-builder/rewards.png"
    [title]="titleVariable() + ' Reward'"
    [description]="titleVariable() + ' custom reward.'"
  />

  <div class="dialog-content">
    <div class="form-group">
      <label class="form-label">Name</label>
      <input
        type="text"
        class="form-input"
        placeholder="Enter reward title"
        [ngModel]="name()"
        (ngModelChange)="name.set($event)"
      />
    </div>

    <div class="form-group">
      <div class="form-label-row">
        <label class="form-label">Description</label>
        <span class="char-count">{{ descriptionLength() }}/{{ maxDescriptionLength }}</span>
      </div>
      <textarea
        class="form-textarea"
        placeholder="Describe your reward"
        [maxlength]="maxDescriptionLength"
        [ngModel]="description()"
        (ngModelChange)="description.set($event)"
      ></textarea>
    </div>

    <div class="form-group">
      <label class="form-label">Cost</label>
      <div class="cost-input-row">
        <input
          type="number"
          class="form-input cost-input"
          placeholder="0"
          min="1"
          [ngModel]="rewardCost()"
          (ngModelChange)="rewardCost.set($event)"
        />
        <mat-icon svgIcon="coin-golden" class="coin-icon"></mat-icon>
      </div>
    </div>
  </div>

  <cb-dialog-footer [loading]="loading()" [saveDisabled]="saveDisabled()" (cancel)="onCancel()" (save)="onSave()" />
</div>
